/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_Invalid_Recurrence_UntilInputs */

const vi_error_work_activity_invalid_recurrence_until = /** @type {(inputs: Error_Work_Activity_Invalid_Recurrence_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày lặp đến không hợp lệ. Vui lòng chọn lại ngày.`)
};

/**

* @param {Error_Work_Activity_Invalid_Recurrence_UntilInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_invalid_recurrence_until = /** @type {((inputs?: Error_Work_Activity_Invalid_Recurrence_UntilInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_Invalid_Recurrence_UntilInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_invalid_recurrence_until(inputs)
});